import Modal from 'components/modal';
import React, {useEffect} from 'react';
import useProductCountDown from 'utilities/hooks/countDownProduct/useProductCountDown';
import EndTimeWarning from './endTimeWarning';
interface CountDownProps {
  post: IGetPostDetail;
  guid: string;
  app: 'farm' | 'wholesaler';
  chosedSugestionUser: IChosedSugestionUser;
  isOpenEndModal: boolean;
  is_saled: boolean;
  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
  setisOpenEndModal: (isOpenEndModal: boolean) => void;
}
const CountDown = ({
  post,
  app,
  guid,
  is_saled,
  isOpenEndModal,
  chosedSugestionUser,
  setChosedSugestionUser,
  setisOpenEndModal,
}: CountDownProps) => {
  const {hours, days} = useProductCountDown(post?.[post.type].expire_date);

  useEffect(() => {
    if (post?.[post.type].is_expired && !is_saled) {
      setisOpenEndModal(true);
    }
  }, [post, is_saled, setisOpenEndModal]);

  return (
    <>
      <div className="flex flex-col w-full gap-4">
        <h5 className="flex w-full justify-center items-center text-gray-5 text-[14px]">
          {post.type === 'sale' && ' زمان باقی‌مانده حراجی'}
          {post.type === 'auction' && 'زمان باقی‌مانده مزایده'}
          {post.type === 'prepayment' && 'زمان باقی‌مانده سلف'}
        </h5>
        <div className="flex w-fll justify-center gap-3">
          <div className="flex flex-col items-center justify-center">
            <div className="bg-gray-200 text-warning-2 w-[50px] h-[50px] flex items-center justify-center rounded-md">
              {hours}
            </div>
            <span className="text-gray-5 font-medium text-[16px]">ساعت</span>
          </div>
          <div className="h-full flex items-center pt-3 text-warning-2">:</div>
          <div className="flex flex-col items-center justify-center">
            <div className="bg-gray-200 w-[50px] text-warning-2 h-[50px] flex items-center justify-center rounded-md">
              {days}
            </div>
            <span className="text-gray-5 font-medium  text-[16px]">روز</span>
          </div>
        </div>
      </div>
      <Modal
        isOnclickBackground={false}
        isOpen={isOpenEndModal}
        setIsOpen={setisOpenEndModal}
      >
        <EndTimeWarning
          guid={guid}
          setisOpenEndModal={setisOpenEndModal}
          setChosedSugestionUser={setChosedSugestionUser}
          chosedSugestionUser={chosedSugestionUser}
          title={post.title}
          app={app}
          type={post.type}
        />
      </Modal>
    </>
  );
};

export default CountDown;
